import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'

export default class DilazioniService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
    this.praticheUrl = `${services.ask_pratiche.url}`
    this.baseUrlFlussi = `${services.ask_base_flussi.url}`
    this.filemanager = new FileManager()
  }

  async getAllDilazioni(clients, view_all){
    let items = []
    let totalItems = 0

    const url = `${this.baseUrl}/clienti/dilazioni/search`
    
    try {
      let res = await this.http.post(url, {clients, view_all})
      res = res.data

      items = Array.isArray(res.data) ? res.data : []
      totalItems = res.meta?.total_items ?? items.length
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  async setPaymentMethodToPostalSlip(invoiceNumber) {
    let item = null
    let success = false

    const url = `${this.baseUrl}/clienti/fatture/${encodeURIComponent(invoiceNumber)}/metodo-pagamento/bollettino-postale`

    try {
      let res = await this.http.post(url, {})
      res = res.data
      item = res?.data && typeof res.data === 'object' ? res.data : null
      success = !!res?.meta?.success
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      item = { message: 'Errore nel cambio del metodo di pagamento' }
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return { item, success }
    }
  }

  async getAllDilazioniNo(opts = {}){
    let item = {}

    if(!Object.keys(opts).length){
      opts = 'no-filters'
    }

    const url = `${this.baseUrl}/clienti/fatture/no-dilazioni/search`

    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      item = (res.data && typeof res.data === 'object' && !Array.isArray(res.data)) ? res.data : {}
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async getClientHasDilazioni(view_all){
    let items = []

    const url = `${this.baseUrl}/clienti/dilazioni/get-clients`
    
    try {
      let res = await this.http.post(url, {view_all: view_all})
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }
  }

  async getRateDilazioniScadenza(params = {}) {
    let items = []
    let pagination = {}
    let sort = {}

    const url = `${this.baseUrl}/clienti/dilazioni/rate-in-scadenza`

    try {
      let res = await this.http.get(url, {
        params: {
          data_inizio: params.data_inizio,
          data_fine: params.data_fine,
          is_saldata: params.is_saldata,
          page: params.page ?? 1,
          per_page: params.per_page ?? 10,
          search: params.search ?? '',
          sort_field: params.sort_field ?? 'data_dilazione_rata',
          sort_order: params.sort_order ?? 'asc',
        }
      })

      res = res.data
      items = res.data || []
      pagination = res.pagination || {}
      sort = res.sort || {}
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return {
      items,
      pagination,
      sort,
    }
  }

  async getDilazioniFirmate(params = {}) {
    let items = []
    let pagination = {}
    let sort = {}

    const url = `${this.baseUrl}/clienti/dilazioni/firmate`

    try {
      let res = await this.http.get(url, {
        params: {
          data_inizio: params.data_inizio,
          data_fine: params.data_fine,
          page: params.page ?? 1,
          per_page: params.per_page ?? 10,
          search: params.search ?? '',
          sort_field: params.sort_field ?? 'data_firma',
          sort_order: params.sort_order ?? 'desc',
        }
      })

      res = res.data
      items = res.data || []
      pagination = res.pagination || {}
      sort = res.sort || {}
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
    } finally {
      this.eventBus.emit('data-loaded')
    }

    return {
      items,
      pagination,
      sort,
    }
  }

  async downloadXmlRid(id){
    const url = `${this.baseUrl}/clienti/dilazioni/${id}/rid/xml`
  
    let httpConfig = {
      url,
      method: 'GET',
      responseType: 'blob',
    }

    try {
      const res = await this.http(httpConfig)
      
      const blob = new Blob([res.data], {type: 'application/xml'});
      const fileName= window.decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8").split('"').join('')
      
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async sendSignRequestDilazione(detail){
    let items = []
    const url = `${this.baseUrlFlussi}/eSign/invia-richiesta-dilazioni`
    
    try {
      let res = await this.http.post(url, {
        dilazione_id: detail.id,
        email: detail.email.trim(),
        nominativo: detail.nominativo.replace(/\s{2,}/g, ' '),
        contatto: detail.contatto.trim()
      })
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      }
    }
  }

  async sendDeleteSignRequestDilazione(detail, user){
    let items = []
    const url = `${this.baseUrlFlussi}/eSign/annulla-richiesta-dilazioni`
    
    try {
      let res = await this.http.post(url, {
        dilazione_id: detail.id,
        user_id: user.id,
        nome: user.nome,
        cognome: user.cognome
      })
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
      }
    }
  }
 
  async downloadPdfLetteraAccettazione(id){
    const url = `${this.baseUrl}/clienti/dilazioni/${id}/lettera-accettazione/pdf`
  
    let httpConfig = {
      url,
      method: 'GET',
      responseType: 'blob',
    }

    try {
      const res = await this.http(httpConfig)
      
      const blob = new Blob([res.data], {type: 'application/xml'});
      const fileName= window.decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8").split('"').join('')
      
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async downloadPdf(id, type_doc){
    const url = `${this.baseUrlFlussi}/eSign/pdf-dilazione`
  
    try {
      let res = await this.http({
        url,
        method: 'POST',
        data: {id,type_doc},
        responseType: 'blob',
      })

      this.filemanager.download(res)
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')   
    }
  }

  async downloadBollettiniPostali(id){
    const url = `${this.baseUrl}/clienti/dilazioni/${id}/bollettini-postali/zip`
  
    let httpConfig = {
      url,
      method: 'GET',
      responseType: 'blob',
    }

    try {
      const res = await this.http(httpConfig)
      
      const blob = new Blob([res.data], {type: 'application/xml'});
      const fileName= window.decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8").split('"').join('')
      
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async sendBollettiniPostaliDilazione(id, email = null) {
    let item = {}
    const url = `${this.baseUrl}/clienti/dilazioni/${id}/bollettini-postali/send-mail`

    try {
      const payload = {}
      if (email) {
        payload.email = email
      }
      const res = await this.http.post(url, payload)
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      item = err?.response?.data || { success: false, message: 'Errore nell\'invio dei bollettini' }
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return { item }
    }
  }

  async makeDilazione(data){
    let item = {}
    let success = false

    const url = `${this.baseUrl}/clienti/dilazioni`
    try {
      let res = await this.http.post(url, {data})
      res = res.data

      item = res.data.item
      success = res.data.success
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item,
        success
      }
    }
  }

  async deleteDilazione(id){
    let success = false

    const url = `${this.baseUrl}/clienti/dilazioni/${id}`
    try {
      let res = await this.http.delete(url)
      res = res.data

      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-load')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        success
      }
    }
  }

  async sendMailDilazione(obj){
    let item = {}

    const url = `${this.baseUrl}/clienti/dilazioni/send/email`

    try {
      let res = await this.http.post(url, {obj})
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async changeStatusDilazione(id, status){
    let item = {}

    const url = `${this.baseUrl}/clienti/dilazioni/set-status`

    try {
      let res = await this.http.post(url, {id: id, status: status})
      item = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        item
      }
    }
  }

  async getTypeStateDilazioni(){
    let items = []

    const url = `${this.baseUrl}/clienti/dilazioni/get-type-state`
    
    try {
      let res = await this.http.get(url)
      items = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items
      }
    }
  }

  async getContattoByDilazione(numeri_fatture) {
    const url = `${this.praticheUrl}/incall/get-contatto-by-dilazione`

    try {
      const numeri = Array.isArray(numeri_fatture)
        ? numeri_fatture
        : [numeri_fatture]

      const res = await this.http.post(url, {
        "numeri": numeri
      })

      this.eventBus.emit('data-loaded')

      return {
        items: res.data?.data ?? []
      }

    } catch (err) {
      this.eventBus.emit('data-load-error', { message: err, url })
      this.eventBus.emit('data-loaded')

      return {
        items: []
      }
    }
  }
}